export default __webpack_public_path__ + "static/media/icon4.6f4ecbba.svg";